// extracted by mini-css-extract-plugin
export default {"row":"ListElementKitchen_row__vRjJ4","header":"ListElementKitchen_header__LTCiT","cell":"ListElementKitchen_cell__ZnnVf"};